// extracted by mini-css-extract-plugin
export default {"container":"style_container__sw-Li","big":"style_big__bvXHh","medium":"style_medium__2AhwD","small":"style_small__vB-Ru"};